import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorTubePainting = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "color-tube-painting" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.055,10.857c.033-.008-2.711-1.632-5.228-3.115A2.7,2.7,0,0,0,.75,10.069v.176a2.446,2.446,0,0,0,1.163,2.081A39.541,39.541,0,0,1,6.331,15.41c1.017.941.107,3.094-1.964,2.04S.2,19.246,2.833,20.892A16.186,16.186,0,0,0,9.162,23.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.584.864l2.751,1.145a1.5,1.5,0,0,1,.8,1.957L17.947,16.43A1.5,1.5,0,0,1,16,17.242L13.244,16.1a1.5,1.5,0,0,1-.8-1.958L17.632,1.677A1.5,1.5,0,0,1,19.584.864Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 12.54,
			y: 6.074,
			width: 10.5,
			height: 5.959,
			transform: "translate(2.596 21.999) rotate(-67.405)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16,17.242,13.244,16.1a1.482,1.482,0,0,1-.477-.32l-.564,4.76,1.376.573,2.979-3.755A1.475,1.475,0,0,1,16,17.242Z"
		})
	]
});
export default SvgColorTubePainting;
